import { shiftApi } from '@/api';
import i18n from '@/i18n';
import { canUnassignShift } from '@/lib/actions/availableShiftActions';
import { showError, showSuccess } from '@/plugins/ToastNotifications';
import { Employee, Shift } from '../../../api/v1';

export const unassignShifts = async (shifts: Shift[]): Promise<void> => {
  shifts = shifts.filter(canUnassignShift);
  let failed = 0;
  let success = 0;

  const unassign = async (id) => {
    await shiftApi
      .updateShift({
        id,
        updateShiftData: {
          employeeId: null,
        },
      })
      .then(() => {
        success += 1;
      })
      .catch(() => {
        failed += 1;
      });
  };

  // eslint-disable-next-line no-restricted-syntax
  for (const { id } of shifts) {
    // eslint-disable-next-line no-await-in-loop
    await unassign(id);
  }

  if (success)
    showSuccess(
      i18n.tc('schedule.numShiftsUnassigned', success, { n: success }),
    );
  if (failed) showError(i18n.tc('errorMessage.unassignShift', failed));
};

export type EmitCreateShiftData = {
  startDate: Date;
  endDate: Date;
  employee?: Employee;
  jobRoleId?: number;
  defaultStartsAt?: Date | null;
  isOpenShift?: boolean;
  locationId?: number | null;
  shiftAreaSessions?: {
    startTime: Date;
    endTime: Date;
    shiftAreaId: number;
  }[];
  showScheduleInput?: boolean;
  showEmployeeInput?: boolean;
};
